import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { cookieService, userService } from "../_services";
import { checkData } from "../utils/checkData";
import { get, map, sortBy, find, isEqual, forEach, some, isEmpty } from "lodash";
import OwlCarousel from 'react-owl-carousel';
import { STRING_CONSTANTS } from "../utils/constants/stringConstants";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../store";
import { api } from "../middleware/api";
import { END_POINTS } from "../utils/constants/endPoints";
import ToastHeader from "../components/toastHeader";
import SuccessToast from "../components/successToast";
import { handleStripePrices } from "../utils/interfaces";
import { UtilityFunctions } from "../utils/UtilityFunctions";
import ValidationErrorToast from "./validationErrorToast";

//@ts-ignore
const StripePrices = forwardRef<handleStripePrices, {}>((props: any, ref) => {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [pricesUpdated, setPricesUpdated] = useState(false);
    const dispatch = useDispatch();
    const { setSelectedPlan } = bindActionCreators(actionCreators, dispatch);

    const options = {
        margin: 10,
        nav: true,
        responsive: {
            0: {
                items: 1,
                stagePadding: 20
            },
            576: {
                items: 2,
                stagePadding: 30
            },
            767: {
                items: 1,
                stagePadding: 30
            },
            800: {
                items: 1,
                stagePadding: 80
            },
            992: {
                items: 1,
                stagePadding: 30
            },
            1200: {
                items: 2,
                stagePadding: 0
            },
            1300: {
                items: 2,
                stagePadding: 80
            },
            1440: {
                items: 2,
                stagePadding: 80
            },
            1600: {
                items: 2,
                stagePadding: 80
            },
            1920: {
                items: 2,
                stagePadding: 80
            }
        },
    }
    useImperativeHandle(
        ref,
        () => ({
            handleSubmit() {
                if (isEmpty(selectedProduct)) {
                    ValidationErrorToast(
                        STRING_CONSTANTS.STRIPE_SUBSCRIPTION.SUBSCRIPTION,
                        STRING_CONSTANTS.STRIPE_SUBSCRIPTION.SELECT_PLAN)
                    return
                }
                let price = find(get(selectedProduct, 'prices'), ['isSelected', true]);
                setSelectedPlan(get(price, 'id'));
                if (props.subscriptionCreation)
                    props.nextButton();
                else {
                    api.post(END_POINTS.stripeSubscription, { priceId: get(price, 'id') }).then(
                        () => {
                            SuccessToast('Subscription', STRING_CONSTANTS.STRIPE_SUBSCRIPTION.UPDATED);
                            api.get(END_POINTS.user, {})
                                .then(res => {
                                    cookieService.saveCookie(STRING_CONSTANTS.cookieStrings.planSelected, res.monthlyAvailableJobPost)
                                    props.setShow(false);
                                    // setTimeout(() => { props.setPlanUpdate(true); }, 1000)
                                    //props.setPlanUpdate(true);
                                })

                        }
                    ).catch(err => ToastHeader(err));
                }
            }
        })
    )

    // useEffect(() => {
    //     userService.fetchAllProducts()
    //         .then((res) => {
    //             let products = sortBy(get(res, 'data', []), 'order')
    //             setProducts(products);
    //             if (props.subscriptionCreation) {
    //                 forEach(products, product => {
    //                     forEach(get(product, 'prices', []), price => {
    //                         price['isSelected'] = price.nickname == STRING_CONSTANTS.STRIPE_SUBSCRIPTION[0] ? true : false;
    //                     })
    //                 });
    //             }
    //             else {
    //                 let selectedProduct = {};
    //                 api.get(END_POINTS.stripeSubscription, null).then(
    //                     subscription => {
    //                         forEach(products, product => {
    //                             forEach(product.prices, price => {
    //                                 let selected_price = find(product.prices, ['id', get(subscription, 'stripePriceId', false)])
    //                                 if (!isEmpty(selected_price))
    //                                     selectedProduct = product;
    //                                 else
    //                                     selected_price = find(product.prices, ['nickname', STRING_CONSTANTS.STRIPE_SUBSCRIPTION[0]])
    //                                 if (selected_price && selected_price.id == price.id)
    //                                     price['isSelected'] = true;
    //                             })
    //                         });
    //                         setSelectedProduct(selectedProduct);
    //                     }).catch(() =>
    //                         forEach(products, product => {
    //                             let selected_price = find(product.prices, ['nickname', STRING_CONSTANTS.STRIPE_SUBSCRIPTION[0]])
    //                             selected_price['isSelected'] = true;
    //                         }));
    //             }
    //         }).then(() => setPricesUpdated(true))
    //         .catch((err) => {
    //             checkData(props, '/', err)
    //         });

    // }, []);

    let getPrice = (prices, index) => {
        return find(prices, { nickname: STRING_CONSTANTS.STRIPE_SUBSCRIPTION[index] })
    }
    let handlePriceChange = (product, selectedPrice) => {
        forEach(product.prices, price => {
            price['isSelected'] = price.id == selectedPrice.id ? true : false;
        });
    }

    let getPriceAmount = (product) => {
        let list = [];
        map([0, 1], value => {
            let price = getPrice(get(product, 'prices'), value);
            list.push(
                <li className="nav-item" role="presentation">
                    <button className={`nav-link ${get(price, 'isSelected') ? 'active' : ''}`} id="pills-home-tab2" data-bs-toggle="pill" data-bs-target="#pills-home2" role="tab" aria-controls="pills-home2" aria-selected="true" onClick={() => { handlePriceChange(product, price) }}><div className="month-name">{get(price, 'nickname')}</div> <div className="price-wrap">{get(product, 'currencySymbol')} {get(price, 'unitAmount')}</div> <div className="border-blue"></div></button>
                </li>)
        })
        return list;
    };

    let getPlans = () => {
        return (!isEmpty(products) &&
            map(products, (product, index) => (
                <div className='item'>
                    <div className={`black-wrap ${(isEqual(selectedProduct, product) && props.subscriptionCreation) ? 'blac-middle' : ''}`}>
                        <div className="level-row">
                            <div className="level-box">
                                <ul>
                                    <li>{get(product, 'name')}</li>
                                    {index == 0 ?
                                        <li>
                                            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="11.5179" cy="10.7931" r="4.48276" fill="white" />
                                                <path d="M15.143 4.34241L15.2261 4.50824L15.8527 6.17448C15.9019 6.30569 16.0054 6.40923 16.1367 6.45846L17.7454 7.062C18.4514 7.32686 18.8307 8.08123 18.6426 8.79496L18.5973 8.93701L17.8489 10.5922C17.7909 10.7198 17.7909 10.8662 17.8489 10.9938L18.5597 12.5581C18.8716 13.2446 18.6064 14.0463 17.9687 14.418L17.8029 14.501L16.1367 15.1276C16.0054 15.1768 15.9019 15.2803 15.8527 15.4116L15.2491 17.0203C14.9843 17.7263 14.2299 18.1056 13.5162 17.9175L13.3741 17.8722L11.7189 17.1238C11.5913 17.0658 11.4449 17.0658 11.3173 17.1238L9.75299 17.8346C9.06652 18.1465 8.26485 17.8813 7.89319 17.2436L7.81012 17.0778L7.18356 15.4116C7.13433 15.2803 7.03079 15.1768 6.89958 15.1276L5.29084 14.524C4.58488 14.2592 4.20551 13.5048 4.39363 12.7911L4.43889 12.649L5.18732 10.9938C5.24529 10.8662 5.24529 10.7198 5.18732 10.5922L4.47654 9.0279C4.16463 8.34142 4.4298 7.53976 5.06751 7.16809L5.23333 7.08502L6.89958 6.45846C7.03079 6.40923 7.13433 6.30569 7.18356 6.17448L7.7871 4.56574C8.05195 3.85978 8.80632 3.48042 9.52006 3.66854L9.66211 3.7138L11.3173 4.46222C11.4449 4.52019 11.5913 4.52019 11.7189 4.46222L13.2832 3.75144C13.9697 3.43953 14.7714 3.7047 15.143 4.34241ZM8.69609 4.90676L8.09254 6.5155C7.94486 6.90915 7.63425 7.21976 7.2406 7.36744L5.63186 7.97099L5.52536 8.02675C5.3362 8.15785 5.26185 8.40933 5.36043 8.62629L6.07121 10.1906C6.24513 10.5734 6.24513 11.0127 6.07121 11.3954L5.3539 12.9748L5.32455 13.0745C5.28349 13.3009 5.40874 13.5313 5.63186 13.6151L7.2406 14.2186C7.63425 14.3663 7.94486 14.6769 8.09254 15.0705L8.69609 16.6793L8.75185 16.7858C8.88295 16.9749 9.13442 17.0493 9.35138 16.9507L10.9157 16.2399C11.2985 16.066 11.7378 16.066 12.1205 16.2399L13.6999 16.9572L13.7996 16.9866C14.026 17.0276 14.2564 16.9024 14.3401 16.6793L14.9437 15.0705C15.0914 14.6769 15.402 14.3663 15.7956 14.2186L17.4044 13.6151L17.5109 13.5593C17.7 13.4282 17.7744 13.1767 17.6758 12.9598L16.965 11.3954C16.7911 11.0127 16.7911 10.5734 16.965 10.1906L17.6823 8.61124L17.7117 8.51155C17.7527 8.28509 17.6275 8.05469 17.4044 7.97099L15.7956 7.36744C15.402 7.21976 15.0914 6.90915 14.9437 6.5155L14.3401 4.90676L14.2844 4.80026C14.1533 4.6111 13.9018 4.53675 13.6848 4.63533L12.1205 5.34611C11.7378 5.52003 11.2985 5.52003 10.9157 5.34611L9.35138 4.63533L9.32109 4.62278C9.07008 4.52861 8.79026 4.65575 8.69609 4.90676Z" fill="white" />
                                            </svg>
                                        </li>
                                        : index == 1 ?
                                            <li>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 23V16H15V23L12 21L9 23Z" fill="white" />
                                                    <circle cx="12" cy="9" r="5" fill="white" />
                                                    <path d="M16.0432 1.80509L16.1358 1.99005L16.8347 3.84855C16.8896 3.99491 17.0051 4.11039 17.1515 4.1653L18.9458 4.83848C19.7332 5.1339 20.1564 5.97531 19.9465 6.7714L19.8961 6.92984L19.0613 8.77602C18.9966 8.91834 18.9966 9.08166 19.0613 9.22397L19.8541 10.9688C20.202 11.7345 19.9062 12.6286 19.1949 13.0432L19.0099 13.1358L17.1515 13.8347C17.0051 13.8896 16.8896 14.0051 16.8347 14.1515L16.1615 15.9458C15.8661 16.7332 15.0247 17.1564 14.2286 16.9465L14.0702 16.8961L12.224 16.0613C12.0817 15.9966 11.9183 15.9966 11.776 16.0613L10.0312 16.8541C9.26553 17.202 8.37136 16.9062 7.95681 16.1949L7.86416 16.0099L7.1653 14.1515C7.11039 14.0051 6.99491 13.8896 6.84855 13.8347L5.05419 13.1615C4.26677 12.8661 3.84364 12.0247 4.05346 11.2286L4.10394 11.0702L4.93872 9.22397C5.00339 9.08166 5.00339 8.91834 4.93872 8.77602L4.14593 7.03121C3.79803 6.26553 4.0938 5.37136 4.80509 4.95681L4.99005 4.86416L6.84855 4.1653C6.99491 4.11039 7.11039 3.99491 7.1653 3.84855L7.83848 2.05419C8.1339 1.26677 8.97531 0.843635 9.7714 1.05346L9.92984 1.10394L11.776 1.93872C11.9183 2.00339 12.0817 2.00339 12.224 1.93872L13.9688 1.14593C14.7345 0.798033 15.6286 1.0938 16.0432 1.80509ZM8.85235 2.43456L8.17917 4.22892C8.01444 4.66799 7.66799 5.01444 7.22892 5.17917L5.43456 5.85235L5.31577 5.91455C5.10478 6.06077 5.02185 6.34127 5.13181 6.58326L5.9246 8.32807C6.11859 8.75502 6.11859 9.24498 5.9246 9.67193L5.12453 11.4335L5.09179 11.5447C5.046 11.7973 5.1857 12.0543 5.43456 12.1477L7.22892 12.8208C7.66799 12.9856 8.01444 13.332 8.17917 13.7711L8.85235 15.5654L8.91455 15.6842C9.06077 15.8952 9.34127 15.9781 9.58326 15.8682L11.3281 15.0754C11.755 14.8814 12.245 14.8814 12.6719 15.0754L14.4335 15.8755L14.5447 15.9082C14.7973 15.954 15.0543 15.8143 15.1477 15.5654L15.8208 13.7711C15.9856 13.332 16.332 12.9856 16.7711 12.8208L18.5654 12.1477L18.6842 12.0855C18.8952 11.9392 18.9781 11.6587 18.8682 11.4167L18.0754 9.67193C17.8814 9.24498 17.8814 8.75502 18.0754 8.32807L18.8755 6.56648L18.9082 6.45528C18.954 6.20269 18.8143 5.94571 18.5654 5.85235L16.7711 5.17917C16.332 5.01444 15.9856 4.66799 15.8208 4.22892L15.1477 2.43456L15.0855 2.31577C14.9392 2.10478 14.6587 2.02185 14.4167 2.13181L12.6719 2.9246C12.245 3.11859 11.755 3.11859 11.3281 2.9246L9.58326 2.13181L9.54947 2.11781C9.2695 2.01278 8.95739 2.15459 8.85235 2.43456Z" fill="white" />
                                                </svg>
                                            </li>
                                            :
                                            <li>
                                                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.9873 20.144L11.363 14.082L14.0524 14.9311L16.2938 11.7932L16.559 12.6897L18.1833 18.7517L15.1212 17.7159L12.9873 20.144Z" fill="white" />
                                                    <path d="M9.7373 20.144L11.3616 14.082L8.67221 14.9311L6.43083 11.7932L6.1656 12.6897L4.54129 18.7517L7.60339 17.7159L9.7373 20.144Z" fill="white" />
                                                    <circle cx="11.3617" cy="8.207" r="4.48276" fill="white" />
                                                    <path d="M14.9868 1.75635L15.0699 1.92218L15.6964 3.58842C15.7457 3.71963 15.8492 3.82317 15.9804 3.8724L17.5891 4.47594C18.2951 4.7408 18.6745 5.49517 18.4864 6.2089L18.4411 6.35095L17.6927 8.00615C17.6347 8.13375 17.6347 8.28017 17.6927 8.40777L18.4034 9.97208C18.7154 10.6586 18.4502 11.4602 17.8125 11.8319L17.6466 11.915L15.9804 12.5415C15.8492 12.5907 15.7457 12.6943 15.6964 12.8255L15.0929 14.4342C14.828 15.1402 14.0737 15.5196 13.3599 15.3314L13.2179 15.2862L11.5627 14.5378C11.4351 14.4798 11.2887 14.4798 11.1611 14.5378L9.59674 15.2485C8.91027 15.5604 8.1086 15.2953 7.73694 14.6576L7.65387 14.4917L7.02731 12.8255C6.97808 12.6943 6.87454 12.5907 6.74332 12.5415L5.13459 11.938C4.42863 11.6731 4.04926 10.9188 4.23738 10.205L4.28264 10.063L5.03107 8.40777C5.08904 8.28017 5.08904 8.13375 5.03107 8.00615L4.32029 6.44184C4.00838 5.75537 4.27355 4.9537 4.91126 4.58203L5.07708 4.49896L6.74332 3.8724C6.87454 3.82317 6.97808 3.71963 7.02731 3.58842L7.63085 1.97968C7.8957 1.27372 8.65007 0.894357 9.36381 1.08248L9.50586 1.12774L11.1611 1.87616C11.2887 1.93414 11.4351 1.93414 11.5627 1.87616L13.127 1.16538C13.8135 0.853472 14.6151 1.11864 14.9868 1.75635ZM8.53984 2.3207L7.93629 3.92944C7.78861 4.32309 7.478 4.6337 7.08435 4.78138L5.47561 5.38493L5.36911 5.44069C5.17995 5.57179 5.1056 5.82327 5.20418 6.04023L5.91496 7.60454C6.08888 7.98732 6.08888 8.42659 5.91496 8.80938L5.19765 10.3887L5.1683 10.4884C5.12724 10.7149 5.25249 10.9453 5.47561 11.029L7.08435 11.6325C7.478 11.7802 7.78861 12.0908 7.93629 12.4845L8.53984 14.0932L8.5956 14.1997C8.7267 14.3889 8.97817 14.4632 9.19513 14.3646L10.7594 13.6539C11.1422 13.4799 11.5815 13.4799 11.9643 13.6539L13.5436 14.3712L13.6433 14.4005C13.8698 14.4416 14.1002 14.3163 14.1839 14.0932L14.7874 12.4845C14.9351 12.0908 15.2457 11.7802 15.6394 11.6325L17.2481 11.029L17.3546 10.9732C17.5438 10.8421 17.6181 10.5907 17.5196 10.3737L16.8088 8.80938C16.6349 8.42659 16.6349 7.98732 16.8088 7.60454L17.5261 6.02518L17.5554 5.92549C17.5965 5.69903 17.4712 5.46863 17.2481 5.38493L15.6394 4.78138C15.2457 4.6337 14.9351 4.32309 14.7874 3.92944L14.1839 2.3207L14.1281 2.2142C13.997 2.02504 13.7456 1.95069 13.5286 2.04927L11.9643 2.76005C11.5815 2.93397 11.1422 2.93397 10.7594 2.76005L9.19513 2.04927L9.16484 2.03672C8.91383 1.94255 8.63401 2.0697 8.53984 2.3207Z" fill="white" />
                                                </svg>
                                            </li>
                                    }
                                </ul>

                            </div>
                            <div className="trail-untill">
                                <div className="icon-wrapc">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.72495 1.3446C8.20071 1.3446 10.2077 3.3516 10.2077 5.82736C10.2077 8.30312 8.20071 10.3101 5.72495 10.3101C3.24919 10.3101 1.24219 8.30312 1.24219 5.82736C1.24219 3.3516 3.24919 1.3446 5.72495 1.3446ZM5.27667 3.58598C5.02909 3.58598 4.82839 3.78668 4.82839 4.03426V6.27564C4.82839 6.52321 5.02909 6.72391 5.27667 6.72391H7.06977C7.31735 6.72391 7.51805 6.52321 7.51805 6.27564C7.51805 6.02806 7.31735 5.82736 7.06977 5.82736H5.72495V4.03426C5.72495 3.78668 5.52425 3.58598 5.27667 3.58598Z" fill="#06EFC5" />
                                    </svg>

                                </div>
                                <div className="date-wrap">
                                    <p>Free trial until</p>
                                    <p>{get(product, 'trialTill')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="tab-section">
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                {getPriceAmount(product)}
                            </ul>

                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                    <ul>
                                        <li>{get(product, 'jobPostAllowed')} job post per month</li>
                                        <li>Suggests employee</li>
                                        <li>1 on 1 Chat</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="btn-wrap">
                            <button className={isEqual(selectedProduct, product) ? "selected" : ''} onClick={() => setSelectedProduct(product)}>{isEqual(selectedProduct, product) ? 'Selected' : 'Select'}</button>
                        </div>
                    </div>
                </div>
            ))
        )
    }

    return (
        props.subscriptionCreation ? pricesUpdated
            // && getPlans() 
            :
            (!isEmpty(selectedProduct) && pricesUpdated &&
                <OwlCarousel className='owl-theme' {...options} key={Date.now()} dotsEach={1} dots={true} nav={true} lazyContent={true} lazyLoad={true} navText={[`<img src=${UtilityFunctions.getImageURL() + "left-icon.svg"}  />`, `<img src=${UtilityFunctions.getImageURL() + "left-right.svg"}  />`]}>
                    {/* {getPlans()} */}
                </OwlCarousel>)

    );
});
export default StripePrices;
